import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { shippingMethodRepository } from '../data-access/repositories/ShippingMethodRepository'

const base = ['vendor', 'shipping-method']

export const shippingMethodQueryConfig = {
  all: () => ({
    queryKey: buildQueryKey(base),
  }),
  list: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => shippingMethodRepository.list(params),
  }),
}
